import React from "react";
import {
  X,
  Phone,
  Mail,
  MapPin,
  MessageCircle,
  UserCheck,
  Trash2,
  Edit,
} from "lucide-react";

const ContactDetailsDrawer = ({ show, contact, onClose, onEdit, onDelete }) => {
  if (!show || !contact) return null;

  const fullName = `${contact.first_name || contact.firstName || ""} ${contact.last_name || contact.lastName || ""}`.trim() || "Friend / Contact";
  const mobile = contact.mobile_number || contact.mobileNo || "";
  const email = contact.email_address || contact.emailId || "";
  const area = contact.area_name || contact.area || "";
  const address = contact.address || "";
  const zipCode = contact.zip_code || contact.zipCode || "";
  const cleanPhone = mobile.replace(/^91/, "");
  const whatsappUrl = cleanPhone ? `https://wa.me/91${cleanPhone}?text=Hi%20${encodeURIComponent(fullName)}` : null;

  return (
    <div className="net-drawer-overlay" onClick={onClose}>
      <div className="net-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="net-drawer__header">
          <h3 className="net-drawer__title">Contact Details</h3>
          <button type="button" className="net-drawer__close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="net-drawer__body">
          {/* Profile Hero */}
          <div className="net-drawer-profile-hero">
            <div
              className="net-drawer-avatar-lg"
              style={{
                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                boxShadow: "0 8px 16px rgba(16, 185, 129, 0.25)",
              }}
            >
              {fullName.charAt(0).toUpperCase()}
            </div>
            <h2 style={{ fontSize: "1.25rem", fontWeight: 800, color: "#0f172a", margin: "0 0 0.35rem 0" }}>
              {fullName}
            </h2>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
              <span
                style={{
                  background: "#f0fdf4",
                  color: "#16a34a",
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  padding: "0.2rem 0.65rem",
                  borderRadius: "9999px",
                  border: "1px solid #bbf7d0",
                  textTransform: "uppercase",
                }}
              >
                Friend / Client Contact
              </span>
            </div>

            {/* Quick action buttons */}
            <div style={{ display: "flex", gap: "0.65rem", justifyContent: "center", marginTop: "1.25rem" }}>
              {mobile && (
                <a href={`tel:${mobile}`} className="net-quick-btn" style={{ flex: "none", padding: "0.5rem 1rem" }}>
                  <Phone size={14} /> Call
                </a>
              )}
              {whatsappUrl && (
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="net-quick-btn net-quick-btn--wa"
                  style={{ flex: "none", padding: "0.5rem 1rem" }}
                >
                  <MessageCircle size={14} /> WhatsApp
                </a>
              )}
              {email && (
                <a href={`mailto:${email}`} className="net-quick-btn" style={{ flex: "none", padding: "0.5rem 1rem" }}>
                  <Mail size={14} /> Email
                </a>
              )}
            </div>
          </div>

          {/* Details */}
          <h4 className="net-drawer-section-title">Contact Information</h4>
          <div className="net-drawer-item-grid">
            <div className="net-drawer-item">
              <div className="net-drawer-item__lbl">Phone Number</div>
              <div className="net-drawer-item__val" style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <Phone size={14} style={{ color: "#16a34a" }} /> +91 {cleanPhone || "Not provided"}
              </div>
            </div>

            <div className="net-drawer-item">
              <div className="net-drawer-item__lbl">Email Address</div>
              <div className="net-drawer-item__val" style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <Mail size={14} style={{ color: "#16a34a" }} /> {email || "Not provided"}
              </div>
            </div>

            {area && (
              <div className="net-drawer-item">
                <div className="net-drawer-item__lbl">Area / Locality</div>
                <div className="net-drawer-item__val" style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <MapPin size={14} style={{ color: "#16a34a" }} /> {area}
                </div>
              </div>
            )}

            {address && (
              <div className="net-drawer-item">
                <div className="net-drawer-item__lbl">Address</div>
                <div className="net-drawer-item__val">{address}</div>
              </div>
            )}

            {zipCode && (
              <div className="net-drawer-item">
                <div className="net-drawer-item__lbl">Postal / Zip Code</div>
                <div className="net-drawer-item__val">{zipCode}</div>
              </div>
            )}
          </div>

          {/* Drawer Actions */}
          <div
            style={{
              display: "flex",
              gap: "0.75rem",
              marginTop: "2rem",
              paddingTop: "1.25rem",
              borderTop: "1px solid #f1f5f9",
            }}
          >
            <button
              type="button"
              className="net-btn net-btn--secondary"
              style={{ flex: 1 }}
              onClick={() => {
                onClose?.();
                onEdit?.(contact);
              }}
            >
              <Edit size={14} /> Edit Contact
            </button>
            <button
              type="button"
              className="net-btn net-btn--danger"
              style={{ flex: 1 }}
              onClick={() => {
                onClose?.();
                onDelete?.(contact);
              }}
            >
              <Trash2 size={14} /> Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetailsDrawer;
